function generateRandomNonce(length) {
  return timestamp() + genRandom(length)
}

function genRandom(length) {
  var arr = new Uint8Array((length || 40) / 2)
  window.crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join('')
}

// dec2hex :: Integer -> String
// i.e. 0-255 -> '00'-'ff'
function dec2hex (dec) {
  return ('0' + dec.toString(16)).substr(-2)
}

function timestamp(){
  return new Date(new Date().toUTCString()).getTime();
}

module.exports = {
  generateRandomNonce
}
